<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useMenuStore } from '~/stores/menu'

const store = useMenuStore()
const { getIsMenuMobileOpen } = storeToRefs(store)

const { toggleMobileMenu } = store
const basketLink = useCookie('basketLink')

const { sendMenuEvent } = useSendEvent()

function basketRedirect() {
    if (!basketLink.value) {
        return
    }

    sendMenuEvent('cart', basketLink.value)

    window.location.href = basketLink.value
}

function handleMobileMenuIcon() {
    sendMenuEvent('Menu')
    toggleMobileMenu()
}
</script>

<template>
    <ul class="relative flex h-8 items-center text-sm md:text-base">
        <li class="hidden h-full border-r border-plus-lp-dark-blue-400 px-4 md:flex md:items-center">
            <a
                href="https://www.plus.pl/kontakt"
                class="plus-lp-focus-link transition duration-400 hover:text-plus-lp-green-one"
                @click="sendMenuEvent('Kontakt', '/kontakt')"
            >
                Kontakt
            </a>
        </li>
        <li
            class="relative flex h-full items-center border-r border-plus-lp-dark-blue-400 px-4"
            :class="{ 'cursor-pointer': basketLink }"
        >
            <div
                :tabindex="basketLink ? '0' : '-1'"
                class="plus-lp-focus-link"
                @click="basketRedirect"
                @keydown.enter.prevent="basketRedirect"
                @keydown.space.prevent="basketRedirect"
            >
                <img
                    src="https://api.plus.pl/file/images_lp/plus_acse_landingpages/menu/Shopping_cart.svg"
                    class="size-9 object-contain p-[6px]"
                    alt="koszyk"
                />
                <span
                    v-if="basketLink"
                    class="absolute right-[14px] top-[-2px] size-3 rounded-full bg-plus-lp-green-one"
                />
            </div>
        </li>
        <li class="hidden h-full border-r border-plus-lp-dark-blue-400 px-4 md:flex md:items-center">
            <a
                href="https://www.plus.pl/udogodnienia"
                class="plus-lp-focus-link"
                @click="sendMenuEvent('udogodnienia', '/udogodnienia')"
            >
                <img
                    src="https://api.plus.pl/file/images_lp/plus_acse_landingpages/menu/accessibility_new.svg"
                    class="size-8 object-contain p-[6px]"
                    alt="dostępność cyfrowa"
                />
            </a>
        </li>

        <li class="flex h-full items-center border-r border-plus-lp-dark-blue-400 px-4 md:border-none md:pr-0">
            <PlusBlogLpOrganismMenuIPlus />
        </li>
        <li class="md:hidden">
            <PlusBlogLpAtomMenubarMobileIcon
                :is-menu-mobile-open="getIsMenuMobileOpen"
                @toggle-mobile-menu="handleMobileMenuIcon"
            />
        </li>
    </ul>
</template>
